module.exports = __webpack_public_path__ + "img/four.37ea9345.svg";